import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import cc from 'classcat';
import React, { useState } from 'react';
import Storage from '@outdoor-voices/ui/dist/utils/Storage';
import { COOKIES } from '../../config/constants';
import Button from '../Button';
import cdnSrc from '../../utils/cdnSrc';
import css from './OVUForm.module.scss';
import ErrorTriangle from '../icons/ErrorTriangle';
import Image from '../Image';
import validEmail from '../../utils/strings/validEmail';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var IMAGE = cdnSrc('images/pages/ovu/ovu-hero-blocks-20220725.jpg');
var COPY = {
  title: 'Study. Sweat. Save.',
  textSet: {
    signup: {
      text: {
        paragraphFirst: 'Calling all college students! Sign up for our OVU perks program with your .edu email to get... ',
        // eslint-disable-line
        paragraphSecond: '',
        // eslint-disable-line
        bullets: ['20% off in shops and online', 'Special perks — ability to earn OV Rewards, early access, event invites, and more']
      }
    },
    login: {
      text: {
        paragraphFirst: 'Hey, college friends! Sign in to your OVU account with your .edu email address to save 20% off sitewide. ',
        // eslint-disable-line
        paragraphSecond: '',
        bullets: []
      }
    }
  }
};
var TERMS_URL = '/pages/ovu-terms';

var OVUForm = function OVUForm() {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      email = _useState2[0],
      setEmail = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      password = _useState4[0],
      setPassword = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      first = _useState6[0],
      setFirst = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      last = _useState8[0],
      setLast = _useState8[1];

  var _useState9 = useState(true),
      _useState10 = _slicedToArray(_useState9, 2),
      isFormSignup = _useState10[0],
      setIsFormSignup = _useState10[1];

  var submitForm = function submitForm(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    var loginForm = document.querySelector('#customer_login');
    var signupForm = document.querySelector('#create_customer');
    var form = isFormSignup ? signupForm : loginForm;
    var shopifyFirstName = document.querySelector('#customer_first_name');
    var shopifyLastName = document.querySelector('#customer_last_name');
    var shopifyEmail = document.querySelector("#customer_email".concat(isFormSignup ? '--create' : ''));
    var shopifyPassword = document.querySelector("#customer_password".concat(isFormSignup ? '--create' : ''));
    var shopifyPasswordConfirmation = document.querySelector('#password_confirmation');

    if (isFormSignup) {
      shopifyFirstName.value = first;
      shopifyLastName.value = last;
      shopifyEmail.value = email;
      shopifyPassword.value = password;
      shopifyPasswordConfirmation.value = password;
      var storage = new Storage();
      storage.set(COOKIES.OVU_CREATE, true);
    } else {
      shopifyEmail.value = email;
      shopifyPassword.value = password;
    }

    form.submit();
  };

  var hasEdu = function hasEdu(emailToCheck) {
    var indexAt = emailToCheck.indexOf('@');
    var indexEdu = emailToCheck.indexOf('.edu');
    return indexAt > -1 && indexEdu > -1 && indexAt < indexEdu;
  };

  var validate = function validate() {
    return hasEdu(email) && validEmail(email);
  };

  var title = COPY.title,
      textSet = COPY.textSet;
  var text = textSet[isFormSignup ? 'signup' : 'login'].text;
  var bullets = text.bullets,
      paragraphFirst = text.paragraphFirst,
      paragraphSecond = text.paragraphSecond;

  var description = /*#__PURE__*/_jsxs(_Fragment, {
    children: [paragraphFirst, /*#__PURE__*/_jsx("ul", {
      className: cc([css.bullets, _defineProperty({}, css.bulletsEmpty, bullets.length < 1)]),
      children: bullets.map(function (bullet) {
        return /*#__PURE__*/_jsx("li", {
          className: css.bullet,
          children: bullet
        }, bullet);
      })
    }), paragraphSecond, /*#__PURE__*/_jsxs("div", {
      className: css.terms,
      children: ["Exclusions apply, \xA0", /*#__PURE__*/_jsx("a", {
        href: TERMS_URL,
        children: "see terms for details."
      })]
    })]
  });

  var formAction = isFormSignup ? 'Create Account' : 'Sign In';
  var valid = validate();
  var emailLabelClass = cc([css.label, _defineProperty({}, css.hasError, email !== '' && !valid)]);

  var stopSubmit = function stopSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
  };

  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.mobileCopy,
      children: [/*#__PURE__*/_jsx("h1", {
        className: css.title,
        children: title
      }), /*#__PURE__*/_jsx("div", {
        className: cc([css.description, _defineProperty({}, css.descriptionSignIn, !isFormSignup)]),
        children: description
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: css.imgWrap,
      children: /*#__PURE__*/_jsx(Image, {
        alt: "OVU Instagram Grid Featuring Outdoor Activities",
        className: css.img,
        src: IMAGE,
        width: 4300,
        sizes: [480, 600, 800, 1200, 1600, 2000]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: css.content,
      children: /*#__PURE__*/_jsxs("form", {
        "aria-label": "Outdoor Voices University (OVU) Account Form",
        className: css.form,
        onSubmit: valid ? submitForm : stopSubmit,
        children: [/*#__PURE__*/_jsxs("div", {
          className: css.desktopCopy,
          children: [/*#__PURE__*/_jsx("div", {
            className: css.title,
            children: title
          }), /*#__PURE__*/_jsx("div", {
            className: css.description,
            children: description
          })]
        }), /*#__PURE__*/_jsx("h1", {
          className: css.signup,
          children: isFormSignup ? 'Sign Up' : 'Sign In'
        }), isFormSignup && /*#__PURE__*/_jsxs("div", {
          className: css.nameWrap,
          children: [/*#__PURE__*/_jsx("div", {
            className: css.fieldWrap,
            children: /*#__PURE__*/_jsxs("label", {
              htmlFor: "form-input-first-name",
              className: css.label,
              children: ["First Name", /*#__PURE__*/_jsx("input", {
                id: "form-input-first-name",
                className: css.input,
                type: "text",
                name: "first",
                value: first,
                onChange: function onChange(e) {
                  return setFirst(e.target.value);
                },
                required: true
              })]
            })
          }), /*#__PURE__*/_jsx("div", {
            className: css.fieldWrap,
            children: /*#__PURE__*/_jsxs("label", {
              htmlFor: "form-input-last-name",
              className: css.label,
              children: ["Last Name", /*#__PURE__*/_jsx("input", {
                id: "form-input-last-name",
                className: css.input,
                type: "text",
                name: "last",
                value: last,
                onChange: function onChange(e) {
                  return setLast(e.target.value);
                },
                required: true
              })]
            })
          })]
        }), /*#__PURE__*/_jsxs("label", {
          htmlFor: "form-input-email",
          className: emailLabelClass,
          children: ["Email (.edu required)", /*#__PURE__*/_jsx("input", {
            id: "form-input-email",
            className: css.input,
            name: "email",
            onChange: function onChange(e) {
              return setEmail(e.target.value);
            },
            required: true,
            type: "email",
            value: email
          }), /*#__PURE__*/_jsx("div", {
            className: css.errorIconWrap,
            children: /*#__PURE__*/_jsx(ErrorTriangle, {})
          })]
        }), /*#__PURE__*/_jsxs("label", {
          htmlFor: "form-input-password",
          className: css.label,
          children: ["Password", /*#__PURE__*/_jsx("input", {
            id: "form-input-password",
            className: css.input,
            minLength: "5",
            name: "password",
            onChange: function onChange(e) {
              return setPassword(e.target.value);
            },
            required: true,
            type: "password",
            value: password
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: css.buttonWrap,
          children: [/*#__PURE__*/_jsx(Button, {
            "aria-label": isFormSignup ? 'Create An Outdoor Voices University Account' : 'Sign In To Your OVU Account',
            title: "".concat(formAction, " To OVU"),
            type: "submit",
            children: formAction
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsxs("button", {
              "aria-label": "Toggle OVU Account Form To ".concat(isFormSignup ? 'Sign In' : 'Sign Up'),
              className: css.toggle,
              onClick: function onClick(event) {
                stopSubmit(event);
                setIsFormSignup(!isFormSignup);
              },
              title: "Toggle OVU Account Form To ".concat(isFormSignup ? 'Sign In' : 'Sign Up'),
              type: "button",
              children: [isFormSignup && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("span", {
                  children: "Have an Account? "
                }), /*#__PURE__*/_jsx("div", {
                  className: css.underlined,
                  children: "Sign In"
                })]
              }), !isFormSignup && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx("span", {
                  children: "Need an Account? "
                }), /*#__PURE__*/_jsx("div", {
                  className: css.underlined,
                  children: "Sign Up"
                })]
              })]
            })
          }), /*#__PURE__*/_jsxs("p", {
            children: [/*#__PURE__*/_jsx("span", {
              children: "Or Sign In With "
            }), /*#__PURE__*/_jsx("a", {
              href: "/pages/student-beans",
              children: "Student Beans"
            })]
          })]
        })]
      })
    })]
  });
};

export default OVUForm;